import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasswordCard = () => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 10) return setError("New password must be at least 10 characters.");
    if (f.next !== f.confirm) return setError("New passwords do not match.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      localStorage.setItem("mv_token", data.access_token);
      setF(EMPTY);
      toast.success("Password updated. Other devices have been signed out.");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Could not update password.");
    } finally {
      setBusy(false);
    }
  };

  const field = (k, label, testid) => (
    <div>
      <Label className="text-xs font-semibold text-muted-foreground">{label}</Label>
      <Input type="password" autoComplete={k === "current" ? "current-password" : "new-password"} value={f[k]}
        onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={testid} className="mt-1.5" required />
    </div>
  );

  return (
    <form onSubmit={submit} className="rounded-2xl bg-white p-6 shadow-sm border border-black/5 space-y-4" data-testid="change-password-card">
      <h2 className="font-heading font-bold text-[#111827]">Change My Password</h2>
      {field("current", "Current Password", "change-password-current")}
      {field("next", "New Password (min 10 characters)", "change-password-new")}
      {field("confirm", "Confirm New Password", "change-password-confirm")}
      {error && <p className="text-sm text-rose-600" data-testid="change-password-error">{error}</p>}
      <Button type="submit" disabled={busy} data-testid="change-password-submit" className="bg-[#0D5C75] hover:bg-[#0a4a5f] text-white">
        <KeyRound size={16} className="mr-1.5" /> {busy ? "Updating…" : "Update Password"}
      </Button>
    </form>
  );
};
